module.exports = __webpack_public_path__ + "img/failure.8852eb7.png";